import { createIcon as o } from "../createIcon.js";
const c = {
  name: "ArrowsUpDownIcon",
  height: 512,
  width: 320,
  svgPath: "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3l0 293.5L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7l0-293.5 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z",
  yOffset: 0,
  xOffset: 0
}, n = o(c);
export {
  n as ArrowsUpDownIcon,
  c as ArrowsUpDownIconConfig,
  n as default
};
